var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18,9.25c0-1.59-.63-3.12-1.76-4.24-1.13-1.13-2.65-1.76-4.24-1.76s-3.12.63-4.24,1.76-1.76,2.65-1.76,4.24v8h12v-8Zm2,8.67l.4.53c.06.07.09.16.1.26,0,.09,0,.19-.05.27-.04.08-.11.15-.18.2-.08.05-.17.07-.26.07H4c-.09,0-.18-.03-.26-.07-.08-.05-.14-.12-.18-.2-.04-.08-.06-.18-.05-.27,0-.09.04-.18.1-.26l.4-.53v-8.67c0-2.12.84-4.16,2.34-5.66,1.5-1.5,3.54-2.34,5.66-2.34s4.16.84,5.66,2.34c1.5,1.5,2.34,3.54,2.34,5.66v8.67Zm-10.5,2.33h5c0,.66-.26,1.3-.73,1.77-.47.47-1.1.73-1.77.73s-1.3-.26-1.77-.73c-.47-.47-.73-1.1-.73-1.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.906391c41e42254c80c7cbc7be683981.svg";
export { ForwardRef as ReactComponent };